import { useReduxState } from 'hooks';
import {
  DisplayFormattedDate,
  User,
  UserPathStepProgress
} from 'components/common';
import { Box, BoxBackLink } from 'components/common/box';
import { PathCompletionStatus } from '.';

import type { GetPathParticipantsRes } from 'shared-types/responses';

interface Props {
  loading: boolean;
  targetUser: GetPathParticipantsRes['users'][0];
}

const PathParticipantSummary = ({ loading, targetUser }: Props) => {
  const { messages, theme } = useReduxState();

  return (
    <div className="summary">
      <Box loading={loading} title={<BoxBackLink simpleReturn={true} />}>
        {targetUser ? (
          <div className="row-lg">
            <div className="col">
              <div className="user">
                <User enableProfileLink={true} user={targetUser} />
              </div>
            </div>
            <div className="col-min">
              <div className="row-sm">
                <div className="col">
                  <div className="stat">
                    <div className="stat-label">{messages.commonAdded}</div>
                    <div className="stat-content">
                      <DisplayFormattedDate date={targetUser.addedToPath} />
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div className="progress">
                    <UserPathStepProgress
                      progressData={targetUser.progressData}
                      progressStyle={{ marginTop: 7 }}
                    />
                  </div>
                </div>
                {targetUser.progressData.pathCompletion ? (
                  <div className="col">
                    <PathCompletionStatus
                      pathCompletion={targetUser.progressData.pathCompletion}
                      showDate={true}
                    />
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        ) : null}
      </Box>

      <style jsx>{`
        .stat {
          display: inline-block;
          margin-right: 50px;
        }
        .stat-label {
          color: ${theme.textColorLight};
          font-size: 1.3rem;
          font-weight: 600;
        }
        .stat-content {
          color: ${theme.textColorLight};
          font-size: 1.4rem;
          font-weight: 700;
        }
        .progress {
          margin-right: 30px;
        }
      `}</style>
    </div>
  );
};

export default PathParticipantSummary;
